import { environment } from 'src/environments/environment';

export function isSentryEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname;
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isLocalHost) {
    return false;
  }

  return environment.name === 'production' || environment.name === 'staging';
}
